<template>
  <section :class="`${$options.name}`">

    <section :class="`${$options.name}-filter`">
      <label>Postcodes</label>
      <p>{{ descriptions.shippingRegionPostcodes }}</p>
      <input type="text" class="postcodes-filter" id="postcodes-filter" v-model="postcodesFilter" placeholder="Type to filter postcodes" />
    </section>

    <!-- Metro Chips -->
    <Chipset label="Metro Postcodes:" variant="metro">
      <vue-tags-input
        v-model="metroTag"
        :tags="tags('metro')"
        :allow-edit-tags="editAllowed"
        :disabled="!editAllowed"
        :add-on-key="[13, ':', ';', 32]"
        placeholder="Add Metro Postcode."
        @tags-changed="newTags => {
          if(!postcodesFilter.length) {
            metroTagset = newTags
          }
        }"
        @before-adding-tag="(payload) => checkTag(payload, 'metro')"
        @before-saving-tag="(payload) => saveTag(payload, 'metro')"
      />
    </Chipset>
    <!-- / Metro Chips -->

    <!-- Non Metro Chips -->
    <Chipset label="Non Metro Postcodes:" variant="nonmetro">
      <vue-tags-input
        v-model="nonMetroTag"
        placeholder="Add Non Metro Postcode"
        :tags="tags('nonMetro')"
        :allow-edit-tags="editAllowed"
        :disabled="!editAllowed"
        :add-on-key="[13, ':', ';', 32]"
        @tags-changed="newTags => {
          if(!postcodesFilter.length) {
            nonMetroTagset = newTags
          }
        }"
        @before-adding-tag="(payload) => checkTag(payload, 'nonMetro')"
        @before-saving-tag="(payload) => saveTag(payload, 'nonMetro')"
      />
    </Chipset>
    <!-- / Non Metro Chips -->
  </section>
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input'
import Chipset from './Chipset'
import PostcodeHelpers from '../lib/PostcodeHelpers'
import Descriptions from '../lib/descriptions.json'

export default {
  name: 'shippingRegionDisplayPostcodes',
  components: {
    VueTagsInput,
    Chipset
  },
  props: {
    regions: {
      type: Array,
      required: true
    },
    region: {
      type: Object,
      required: true
    },
    editAllowed: {
      type: Boolean,
      required: true
    },
    metro: {
      type: [Object, Array],
      required: true
    },
    nonMetro: {
      type: [Object, Array],
      required: true
    }
  },
  data: function () {
    return {
      postcodesFilter: '',
      metroTag: '',
      metroTagset: [],
      nonMetroTag: '',
      nonMetroTagset: [],
      descriptions: Descriptions
    }
  },
  computed: {
  },
  mounted: function () {
    this.metroTagset = this.metro.map((postcode, idx) => {
      return {
        id: idx,
        text: postcode,
        tiClasses: ['vi-valid'],
        originalValue: postcode
      }
    })

    this.nonMetroTagset = this.nonMetro.map((postcode, idx) => {
      return {
        id: idx,
        text: postcode,
        tiClasses: ['vi-valid'],
        originalValue: postcode
      }
    })
  },
  methods: {
    checkTag: function (obj, type) {
      const excludes = [obj.tag.originalValue]
      let tagset = null

      tagset = [...this.metroTagset, ...this.nonMetroTagset].reduce((acc, val) => {
        acc.push(val.text)
        return acc
      }, [])

      if (!PostcodeHelpers.postCodeIsUsed(obj.tag.text, tagset, excludes)) {
        PostcodeHelpers.validatePostcode(this.regions, obj, [this.region.title], this).then(
          resolveObj => { resolveObj.instance.addTag() },
          error => { this.$emit('notification', { message: error, type: 'error' }) }
        )
      } else {
        this.$emit('notification', { message: 'Postcode already exists in the current region.', type: 'error' })
      }
    },
    saveTag: function (obj, type) {
      const tag = obj.tag.text
      const regionExcludes = [this.region.title]
      const tagExcludes = [obj.tag.originalValue]

      const tagset = [...this.metroTagset, ...this.nonMetroTagset].reduce((acc, val) => {
        acc.push(val.text)
        return acc
      }, [])

      /**
       * Check against current tagset.
       *
       * Exclusions:
       *  - The current tags original value.
       */
      if (PostcodeHelpers.postCodeIsUsed(tag, tagset, tagExcludes)) {
        this.$emit('notification', { message: 'Postcode already exists in the current region.', type: 'error' })
        return
      }

      /**
       * Check against all regions.
       *
       * Exclusions:
       *  - Current region as tagset has already been checked and is hard to define which tags have been edited
       * or not.
       */
      PostcodeHelpers.validatePostcode(this.regions, obj, regionExcludes, this).then(
        resolveObj => {
          const metroTagIndex = resolveObj.context.metroTagset.findIndex(metroTag => {
            return parseInt(metroTag.id) === parseInt(resolveObj.instance.tag.id)
          })

          if (metroTagIndex !== -1) {
            resolveObj.context.metroTagset[metroTagIndex].text = resolveObj.instance.tag.text
            resolveObj.instance.tag.originalValue = resolveObj.instance.tag.text
            resolveObj.instance.saveTag()

            resolveObj.context.$emit('notification', { message: 'Postcode Updated successfully.', type: 'success' })
          }
        },
        error => { this.$emit('notification', { message: error, type: 'error' }) }
      )
    },
    tags: function (type = null) {
      const helper = PostcodeHelpers
      const filter = this.postcodesFilter
      const tagset = (type === 'metro') ? this.metroTagset : this.nonMetroTagset

      if (filter.length && !Number.isNaN(parseInt(filter)) && helper.isValidPostcode(filter)) {
        return tagset.filter((tag, idx) => {
          const postcode = tag.text

          if (helper.isRangeSet(postcode) !== -1) {
            const tagRange = helper.retrieveRangeValues(postcode)
            const tagMin = tagRange.min
            const tagMax = tagRange.max

            if (helper.isRangeSet(filter) !== -1) {
              const filterRange = helper.retrieveRangeValues(filter)
              const filterMin = filterRange.min
              const filterMax = filterRange.max

              // If filter min is below the tag minimum, remove it
              if (filterMin < tagMin || filterMin > tagMax) { return false }
              if (filterRange.min > tagMin && filterRange.min < tagMax) { return true }
              if (filterMax < tagMax && filterMax > tagMin) { return true }
            } else {
              if (parseInt(filter) === tagMin || parseInt(filter) === tagMax) { return true }
              if (parseInt(filter) > tagMin && parseInt(filter) < tagMax) { return true }
              if (parseInt(filter) < tagMin || parseInt(filter) > tagMax) { return false }
            }
          } else {
            if (parseInt(filter) === parseInt(postcode)) {
              return true
            }
          }
        })
      }

      return tagset
    }
  }
}
</script>

<style lang="scss" scoped>
 .shippingRegionDisplayPostcodes {
   margin-top: 1em;

   &-filter {
    margin-bottom: 1em;

     label {
        margin-right: 1em;
        font-weight: bold;
     }

     input {
      border-radius: 6px;
      outline: none;
      box-shadow: none;
      padding: 0.25em 1.5em 0.25em 0.75em;
      width: 100%;
      border: 1px solid rgba(0, 0, 0, 0.1);
     }
   }
 }
</style>
